<!-- Useless Now -->

<template>
  <div>
    <productDetail :value="product"></productDetail>
  </div>
</template>
<script type="text/javascript">
import { FITFormCard, FITCheckbox, FITSelect, FITTextInput, FITInputTag, FITButton } from '@/components'
import { mapGetters } from 'vuex'
import ProductDetail from '@/Product/containers/ProductDetail'
import $ from 'jquery'


export default {
  name: 'KOLProduct',
  components: {
    FITCheckbox,
    FITSelect,
    FITTextInput,
    FITInputTag,
    FITButton,
    FITFormCard,
    ProductDetail
  },
  props: {
    value: {
      type: Object,
      default: () => { return {} },
    }
  },
  data() {
    return {
      product: this.value
    }
  },
  created() {
    // need to get detail from Product Link
    this.getKOLProductDetail();
  },
  mounted() {},
  watch: {},
  computed: {

  },
  methods: {
    getKOLProductDetail() {
      let param = [];
      if (!$.isEmptyObject(this.value)) {
        param.push({
          key: 'link',
          value: this.value.link
        });
      } else {
        let link = this.$router.currentRoute.query.link;
        console.log(link);
        param.push({
          key: 'link',
          value: link
        });
      }

      this.$store.dispatch('Shop/getKOLProductDetail', param).then((json) => {
        this.product = json.data;
        // console.log(json.data);
      })
    }
  },
}

</script>
<style type="text/css">
</style>



// WEBPACK FOOTER //
// src/Shop/containers/KOLProduct.vue